import React from "react";
import { Button } from "~/components/ui/button";

interface Props {
  copyContent: string;
  buttonProps?: React.ComponentProps<typeof Button>;
  children: React.ReactNode;
  onCopy: () => void;
  onFail: () => void;
}

const CopyButton = ({ copyContent, buttonProps, children, onCopy, onFail }: Props) => {
  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(copyContent);
      onCopy();
    } catch {
      onFail();
    }
  };

  return (
    <Button {...buttonProps} onClick={onClick}>
      {children}
    </Button>
  );
};

export default CopyButton;
